const middleware = {}

middleware['authext'] = require('..\\middleware\\authext.js')
middleware['authext'] = middleware['authext'].default || middleware['authext']

export default middleware
